'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * Custom react hook to handle outside click events
 *
 * @param {function} onClickAway - will be called if clicked outside
 * @return {Ref} _ref - Ref to be used in the target element
 */

var useClickAway = function useClickAway(onClickAway) {
  var _ref = React.useRef(null);

  var clickHandler = function clickHandler(event) {
    if (_ref.current && !_ref.current.contains(event.target)) {
      onClickAway && onClickAway(event);
    }
  };

  React.useEffect(function () {
    document.addEventListener('mousedown', clickHandler);
    return function () {
      document.removeEventListener('mousedown', clickHandler);
    };
  }, []);
  return _ref;
};

exports.default = useClickAway;
